<!-- crm高科技行业解决方案模块 -->

<template>
  <div class="crmTech_solution_box">
      <div class="sheets_box">
        <div
          class="sheet_content"
          :style="{
            'background-image': 'url(' + bgData + ')',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
            width: '1344px',
            height: '766px',
          }"
          :class="{ title_en: $i18n.locale === 'en_US',title_ja:$i18n.locale === 'ja_JP'}"
        >
          <!-- 标题行 -->
          <div class="text_title title_height display_center" style="width:124px;top: 1.2rem; left: 0rem;">{{$t('solution_crm.high-tech.solutions.headline.title01')}}</div>
          <div class="text_title title_height display_center" style="width:1050px;top: 1.2rem; left: 14.8rem">{{$t('solution_crm.high-tech.solutions.headline.title02')}}</div>
          <div class="text_title title_height display_center" style="width:124px;top: 1.2rem; right: 0.3rem">{{$t('solution_crm.high-tech.solutions.headline.title03')}}</div>
          <div class="text_title title_height display_center" style="width:885px;top: 15rem; left: 14.8rem">{{$t('solution_crm.high-tech.solutions.headline.title04')}}</div>
          <div class="text_title title_height display_center" style="width:145px;top: 15rem; left: 105.3rem">{{$t('solution_crm.high-tech.solutions.headline.title05')}}</div>
          <div class="text_title title_height display_center" style="width:205px;top: 29rem; left: 14.8rem">{{$t('solution_crm.high-tech.solutions.headline.title06')}}</div>
          <div class="text_title title_height display_center" style="width:214px;top: 29rem; left: 37.2rem">{{$t('solution_crm.high-tech.solutions.headline.title07')}}</div>
          <div class="text_title title_height display_center" style="width:205px;top: 29rem; left: 60.5rem">{{$t('solution_crm.high-tech.solutions.headline.title08')}}</div>
          <div class="text_title title_height display_center" style="width:205px;top: 29rem; left: 82.8rem">{{$t('solution_crm.high-tech.solutions.headline.title09')}}</div>
          <div class="text_title title_height display_center" style="width:205px;top: 49rem; left: 14.8rem">{{$t('solution_crm.high-tech.solutions.headline.title10')}}</div>
          <div class="text_title title_height display_center" style="width:214px;top: 49rem; left: 37.2rem">{{$t('solution_crm.high-tech.solutions.headline.title11')}}</div>
          <div class="text_title title_height display_center" style="width:205px;top: 49rem; left: 60.5rem">{{$t('solution_crm.high-tech.solutions.headline.title12')}}</div>
          <div class="text_title title_height display_center" style="width:205px;top: 49rem; left: 82.8rem">{{$t('solution_crm.high-tech.solutions.headline.title13')}}</div>

          <!-- 第一列 渠道门户部分 -->
          <div class="text_normal text_normal1_1 text_normal1_ja" style="top: 7.5rem; left: 3.3rem;" >{{$t('solution_crm.high-tech.solutions.tab01.title01')}}</div>
          <div class="text_normal text_normal1_2" style="top: 18.6rem; left: 3.3rem;" >{{$t('solution_crm.high-tech.solutions.tab01.title02')}}</div>
          <div class="text_normal text_normal1" style="top: 29.5rem; left: 3.3rem;" >{{$t('solution_crm.high-tech.solutions.tab01.title03')}}</div>
          <div class="text_normal text_normal1" style="top: 40.5rem; left: 3.3rem;" >{{$t('solution_crm.high-tech.solutions.tab01.title04')}}</div>
          <div class="text_normal text_normal1" style="top: 51.6rem; left: 3.3rem;" >{{$t('solution_crm.high-tech.solutions.tab01.title05')}}</div>
          <div class="text_normal text_normal1" style="top: 62.5rem; left: 3.3rem;" >{{$t('solution_crm.high-tech.solutions.tab01.title06')}}</div>

          <!-- 第二列 第一行 决策分析部分-->
          <div class="text_normal" style="top: 6.6rem; left: 19.8rem">
            {{$t('solution_crm.high-tech.solutions.tab02.title01')}}
          </div>
          <div class="text_normal" style="top: 6.6rem; left: 34.5rem">
            {{$t('solution_crm.high-tech.solutions.tab02.title02')}}
          </div>
          <div class="text_normal" style="top: 6.6rem; left: 49rem">
            {{$t('solution_crm.high-tech.solutions.tab02.title03')}}
          </div>
          <div class="text_normal" style="top: 6.6rem; left: 64.1rem">
            {{$t('solution_crm.high-tech.solutions.tab02.title04')}}
          </div>
          <div class="text_normal text_normal1_1_ja" style="top: 6.6rem; left: 79rem">
            {{$t('solution_crm.high-tech.solutions.tab02.title05')}}
          </div>
          <div class="text_normal" style="top: 6.6rem; left: 94rem">
            {{$t('solution_crm.high-tech.solutions.tab02.title06')}}
          </div>
          <div class="text_normal text_normal1_3" style="top: 6.6rem; left: 108.5rem">
            {{$t('solution_crm.high-tech.solutions.tab02.title07')}}
          </div>
          
          <!-- 第二列 第二行 运营管理部分-->
          <div class="text_normal text_normal2_1" style="top: 20.4rem; left: 21rem">
            {{$t('solution_crm.high-tech.solutions.tab03.title01')}}
          </div>
          <div class="text_normal text_normal2_2" style="top: 20.4rem; left: 38.5rem">
            {{$t('solution_crm.high-tech.solutions.tab03.title02')}}
          </div>
          <div class="text_normal" style="top: 20.4rem; left: 55.8rem">
            {{$t('solution_crm.high-tech.solutions.tab03.title03')}}
          </div>
          <div class="text_normal text_normal2 text_normal2_1_ja" style="top: 20.4rem; left: 72.5rem">
            {{$t('solution_crm.high-tech.solutions.tab03.title04')}}
          </div>
          <div class="text_normal text_normal2_3" style="top: 20.4rem; left: 90.8rem">
            {{$t('solution_crm.high-tech.solutions.tab03.title05')}}
          </div>
          <!-- 第二列  第三、四行  市场管理、销售管理、合同管理、订单管理-->
          <div class="text_normal text_normal3_1_ja" style="top: 34.15rem; left: 17.1rem">
            {{$t('solution_crm.high-tech.solutions.tab04.title01')}}
          </div>
          <div class="text_normal text_normal3_1" style="top: 34.15rem; left: 26.55rem">
            {{$t('solution_crm.high-tech.solutions.tab04.title02')}}
          </div>
          <div class="text_normal text_normal3_2" style="top: 40.3rem; left: 17.1rem">
            {{$t('solution_crm.high-tech.solutions.tab04.title03')}}
          </div>
          <div class="text_normal text_normal3_1 text_normal3_2_ja" style="top: 40.3rem; left: 26.55rem">
            {{$t('solution_crm.high-tech.solutions.tab04.title04')}}
          </div>

          <div class="text_normal text_normal4_1" style="top: 34.15rem; left: 39.5rem">
            {{$t('solution_crm.high-tech.solutions.tab05.title01')}}
          </div>
          <div class="text_normal text_normal4_2 text_normal4_1_ja" style="top: 34.15rem; left: 48.6rem">
            {{$t('solution_crm.high-tech.solutions.tab05.title02')}}
          </div>
          <div class="text_normal text_normal4_1" style="top: 40.3rem; left: 39.5rem">
            {{$t('solution_crm.high-tech.solutions.tab05.title03')}}
          </div>
          <div class="text_normal text_normal4_3" style="top: 40.3rem; left: 49.5rem">
            {{$t('solution_crm.high-tech.solutions.tab05.title04')}}
          </div>

          <div class="text_normal text_normal4_2_ja" style="top: 34.15rem; left: 62.7rem">
            {{$t('solution_crm.high-tech.solutions.tab06.title01')}}
          </div>
          <div class="text_normal" style="top: 34.15rem; left: 72.2rem">
            {{$t('solution_crm.high-tech.solutions.tab06.title02')}}
          </div>
          <div class="text_normal" style="top: 40.3rem; left: 62.7rem">
            {{$t('solution_crm.high-tech.solutions.tab06.title03')}}
          </div>
          <div class="text_normal" style="top: 40.3rem; left: 72.2rem">
            {{$t('solution_crm.high-tech.solutions.tab06.title04')}}
          </div>
          
          <div class="text_normal" style="top: 34.15rem; left: 85.15rem">
            {{$t('solution_crm.high-tech.solutions.tab07.title01')}}
          </div>
          <div class="text_normal" style="top: 34.15rem; left: 94.6rem">
            {{$t('solution_crm.high-tech.solutions.tab07.title02')}}
          </div>
          <div class="text_normal" style="top: 40.3rem; left: 85.15rem">
            {{$t('solution_crm.high-tech.solutions.tab07.title03')}}
          </div>
          <div class="text_normal" style="top: 40.3rem; left: 94.6rem">
            {{$t('solution_crm.high-tech.solutions.tab07.title04')}}
          </div>

          <!-- 第二列 第五六行 客户管理、竞争对手、产品管理、用户/权限 -->
          <div class="text_normal text_normal5_1_ja" style="top: 55rem; left: 17.1rem">
            {{$t('solution_crm.high-tech.solutions.tab08.title01')}}
          </div>
          <div class="text_normal text_normal5" style="top: 55rem; left: 27.5rem">
            {{$t('solution_crm.high-tech.solutions.tab08.title02')}}
          </div>
          <div class="text_normal" style="top: 62.8rem; left: 17.1rem">
            {{$t('solution_crm.high-tech.solutions.tab08.title03')}}
          </div>
          <div class="text_normal" style="top: 62.8rem; left: 26.55rem">
            {{$t('solution_crm.high-tech.solutions.tab08.title04')}}
          </div>

          <div class="text_normal text_normal6_1" style="top: 55rem; left: 44.6rem">
            {{$t('solution_crm.high-tech.solutions.tab09.title01')}}
          </div>
          <div class="text_normal text_normal6_2 text_normal5_2_ja" style="top: 62.8rem; left: 44.6rem">
            {{$t('solution_crm.high-tech.solutions.tab09.title02')}}
          </div>

          <div class="text_normal" style="top: 55rem; left: 62.8rem">
            {{$t('solution_crm.high-tech.solutions.tab10.title01')}}
          </div>
          <div class="text_normal text_normal6_1_ja" style="top: 55rem; left: 72.3rem">
            {{$t('solution_crm.high-tech.solutions.tab10.title02')}}
          </div>
          <div class="text_normal text_normal6_2_ja" style="top: 62.8rem; left: 62.8rem">
            {{$t('solution_crm.high-tech.solutions.tab10.title03')}}
          </div>
          <div class="text_normal" style="top: 62.8rem; left: 72.3rem">
            {{$t('solution_crm.high-tech.solutions.tab10.title04')}}
          </div>

          <div class="text_normal text_normal7_1 text_normal7_1_ja" style="top: 55rem; left: 85.17rem">
            {{$t('solution_crm.high-tech.solutions.tab11.title01')}}
          </div>
          <div class="text_normal text_normal7_2" style="top: 55rem; left: 94.6rem">
            {{$t('solution_crm.high-tech.solutions.tab11.title02')}}
          </div>
          <div class="text_normal text_normal7_1" style="top: 62.8rem; left: 85.17rem">
            {{$t('solution_crm.high-tech.solutions.tab11.title03')}}
          </div>
          <div class="text_normal text_normal7_3 text_normal7_2_ja" style="top: 62.8rem; left: 94.6rem">
            {{$t('solution_crm.high-tech.solutions.tab11.title04')}}
          </div>
          

          <!-- 第三列 渠道管理部分 -->
          <div class="text_normal text_normal8_1" style="top: 20.4rem; left: 109.2rem">
            {{$t('solution_crm.high-tech.solutions.tab12.title01')}}
          </div>
          <div class="text_normal text_normal8_2 text_normal8_1_ja" style="top: 26.5rem; left: 109.2rem">
            {{$t('solution_crm.high-tech.solutions.tab12.title02')}}
          </div>
          <div class="text_normal text_normal8_1" style="top: 32.7rem; left: 109.2rem">
            {{$t('solution_crm.high-tech.solutions.tab12.title03')}}
          </div>
          <div class="text_normal text_normal8_1" style="top: 38.9rem; left: 109.2rem">
            {{$t('solution_crm.high-tech.solutions.tab12.title04')}}
          </div>
          <div class="text_normal text_normal8_3" style="top: 45rem; left: 107.8rem">
            {{$t('solution_crm.high-tech.solutions.tab12.title05')}}
          </div>
          <div class="text_normal text_normal8_4" style="top: 51.2rem; left: 109.2rem">
            {{$t('solution_crm.high-tech.solutions.tab12.title06')}}
          </div>
          <div class="text_normal text_normal8_1" style="top: 57.4rem; left: 108.5rem">
            {{$t('solution_crm.high-tech.solutions.tab12.title07')}}
          </div>
          <div class="text_normal text_normal8_1 text_normal8_2_ja" style="top: 63.4rem; left: 109.2rem">
            {{$t('solution_crm.high-tech.solutions.tab12.title08')}}
          </div>
          <!-- 最后一列 移动端 -->
          <div class="text_normal text_normal9_1 text_normal9_1_ja" style="top: 7.5rem; left: 124.8rem;" >{{$t('solution_crm.high-tech.solutions.tab13.title01')}}</div>
          <div class="text_normal text_normal9_2" style="top: 15.7rem; left: 124.8rem;" >{{$t('solution_crm.high-tech.solutions.tab13.title02')}}</div>
          <div class="text_normal text_normal9_1" style="top: 23.8rem; left: 124.8rem;" >{{$t('solution_crm.high-tech.solutions.tab13.title03')}}</div>
          <div class="text_normal text_normal9 text_normal9_3 text_normal9_2_ja" >{{$t('solution_crm.high-tech.solutions.tab13.title04')}}</div>
          <div class="text_normal text_normal9_1" style="top: 40.3rem; left: 124.8rem;" >{{$t('solution_crm.high-tech.solutions.tab13.title05')}}</div>
          <div class="text_normal text_normal9_4" style="top: 48rem; left: 126rem;" >{{$t('solution_crm.high-tech.solutions.tab13.title06')}}</div>
          <div class="text_normal text_normal9_1 text_normal9_3_ja" style="top: 55.5rem; left: 124.8rem;" >{{$t('solution_crm.high-tech.solutions.tab13.title07')}}</div>
          <div class="text_normal text_normal10 text_normal9_5 text_normal9_4_ja" >{{$t('solution_crm.high-tech.solutions.tab13.title08')}}</div>
          
          

          <!-- 倒数第一行 白字 -->
        <div class="text_white bottom_text display_dir_row">
          <div class="bottom_text_width display_center">
            {{$t('solution_crm.high-tech.solutions.tab14.title01')}}
          </div>
          <div class="bottom_text_width display_center">
            {{$t('solution_crm.high-tech.solutions.tab14.title02')}}
          </div>
          <div class="bottom_text_width display_center">
            {{$t('solution_crm.high-tech.solutions.tab14.title03')}}
          </div>
        </div>
        </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'crmHighTechSolution',
  data () {
    return {
      bgData: require('../../../../assets/images/IndustrySolution/crm/highTech/highTech_solution_bg.png'),
    }

  }
}
</script>